export default __webpack_public_path__ + "static/media/Gwent-Mod3-ParticipantGuide.9fba3a8c.pdf";